"use strict";
exports.__esModule = true;
var react_1 = require("react");
var utils_1 = require("@lglp/utils");
var ramda_1 = require("ramda");
var findQuery = function (queries) {
    return queries.find(function (_a) {
        var query = _a.query;
        return !query ||
            (utils_1.canUseDOM() && window.matchMedia && window.matchMedia(query).matches);
    }) || {};
};
var forEachQueries = function (callback, queries) {
    queries === null || queries === void 0 ? void 0 : queries.forEach(function (_a) {
        var query = _a.query;
        if (query) {
            utils_1.canUseDOM() && window.matchMedia && callback(window.matchMedia(query));
        }
    });
};
/**
 * Hook to get props depends of media query.
 *
 * @param {Array} queries list of query with props order by importance
 * @returns {Object} props that match the first query in queries
 *
 * @example
 * const queryProps = useMediaQueries([
 *  { query: '(min-width: 750px)', nbVisibleItems: 3 },
 *  { query: '(min-width: 480px)', nbVisibleItems: 2 },
 *  { nbVisibleItems: 1 } // default props
 * ]);

 * return <Carousel {...props} {...queryProps} />;
 */
var useMediaQueries = function (queries) {
    if (queries === void 0) { queries = []; }
    var _a = react_1.useState(findQuery(queries)), props = _a[0], setProps = _a[1];
    react_1.useEffect(function () {
        var updateMatch = function () {
            setProps(findQuery(queries));
        };
        updateMatch();
        forEachQueries(function (mediaQuery) { return mediaQuery.addEventListener('change', updateMatch); }, queries);
        return function () {
            forEachQueries(function (mediaQuery) { return mediaQuery.removeEventListener('change', updateMatch); }, queries);
        };
    }, 
    // we do a deep comparaison in this case
    [JSON.stringify(queries)]);
    return ramda_1.omit(['query'], props);
};
exports["default"] = useMediaQueries;
//# sourceMappingURL=useMediaQueries.js.map